<template>
   <sup
      ><span
         >[<template v-for="(ref, i) of references" :key="`ref-${ref}`">
            <button @click="scrollToRef(ref)">{{ ref }}</button>
            <span class="sr-only"> Scroll to reference: {{ ref }} </span>
            <span v-if="i + 1 < references.length">{{ ", " }}</span> </template
         >]</span
      ></sup
   >
</template>

<script setup lang="ts">
const props = defineProps<{
   text: string;
}>();

const references = computed<string[]>(() => {
   // transform text into an array of reference numbers. For example, from '[1, 10]' to ['1', '10'].
   const matches = props.text.match(/\d+/g);
   return matches.map(String);
});

const scrollToRef = (referenceNumber) => {
   const section = document.getElementById(`ref-${referenceNumber}`);
   section.scrollIntoView({ behavior: "smooth", block: "start" });
   section.focus();
};
</script>
